import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wheelchairFilled"
const WheelchairFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M8.25 10.875C8.848 10.875 9.421 10.975 9.956 11.159 11.871 11.817 13.286 13.551 13.477 15.64Q13.5 15.879 13.501 16.125C13.5 19.025 11.15 21.375 8.25 21.375S2.998 19.025 2.998 16.125 5.351 10.875 8.25 10.875M8.25 13.5C6.8 13.5 5.625 14.675 5.625 16.125S6.8 18.75 8.25 18.75 10.875 17.575 10.875 16.125Q10.875 16.033 10.867 15.943L10.862 15.878C10.742 14.585 9.685 13.565 8.376 13.503z"
            clipRule="evenodd"
          />
          <path d="M17.625 1.5C19.075 1.5 20.25 2.675 20.25 4.125S19.075 6.75 17.625 6.75Q17.226 6.748 16.862 6.637C17.405 6.99 17.613 7.691 17.338 8.286L15.678 11.88 19.76 12.968C20.577 13.186 20.978 14.105 20.583 14.851L17.696 20.3C17.468 20.731 17.022 21 16.536 21H16.22C15.69 21 15.296 20.506 15.415 19.99L16.333 16.011 14.993 15.836C14.882 13.184 13.24 10.928 10.928 9.927L12.134 8.32 10.726 6.912 7.977 8.287C7.287 8.632 6.483 8.183 6.385 7.447L6.375 7.297 6.382 7.172C6.415 6.882 6.56 6.616 6.79 6.432L10.11 3.776 10.19 3.717C10.572 3.456 11.065 3.416 11.485 3.612L11.573 3.658 15.86 6.068C15.33 5.587 14.999 4.894 14.999 4.124 15 2.675 16.176 1.5 17.626 1.5" />
        </svg>
      }
    </span>
  )
}
export default WheelchairFilledIcon
